export var DEFAULT_ERROR = 'Поле заполнено некорректно';